import { useEffect, useState } from 'react'
import type { AudioWaveformProps } from './AudioWaveform'
import { getHeight } from './AudioWaveform.styles'
import { compress } from './compress'

export interface UseAudioWaveformProps {
  data: AudioWaveformProps['data']
  numberOfBars: AudioWaveformProps['numberOfBars']
  size: AudioWaveformProps['size']
}

export interface UseAudioWaveformValues {
  minHeight: number
  maxHeight: number
  getHeight: (value: number) => number
  state: number[]
}

export const useAudioWaveform = (
  props: UseAudioWaveformProps
): UseAudioWaveformValues => {
  const [state, setState] = useState<number[]>([])

  useEffect(() => {
    setState(compress(props.data, props.numberOfBars))
  }, [props.data, props.numberOfBars])

  const { minHeight, maxHeight } = getHeight(props.size)

  function getDynamicHeight(value: number) {
    return Math.min(minHeight + maxHeight * value, maxHeight)
  }

  return {
    minHeight,
    maxHeight,
    getHeight: getDynamicHeight,
    state
  }
}
